import { render, staticRenderFns } from "./modalEquipaments.vue?vue&type=template&id=55011a04&scoped=true&"
import script from "./modalEquipaments.vue?vue&type=script&lang=js&"
export * from "./modalEquipaments.vue?vue&type=script&lang=js&"
import style0 from "./modalEquipaments.vue?vue&type=style&index=0&id=55011a04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55011a04",
  null
  
)

export default component.exports